function fnPeopleCarousel(i, oSection) {
  new Swiper(oSection.querySelector(".swiper"), {
		loop: true,
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: 3,
    loop: true,
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: false,
    },
    navigation: {
      nextEl: oSection.querySelector(".arrows .next"),
      prevEl: oSection.querySelector(".arrows .prev"),
    },
    pagination: {
      el: oSection.querySelector(".progress-bar"),
      type: "progressbar",
    },
  });
}
